/* eslint-disable react/jsx-no-literals */

import cn from "classnames";
import * as React from "react";

import styles from "./Footer.module.scss";

export const FooterLinksResponsive = ({
  className,
}: {
  className?: string;
}) => (
  <nav className={cn(styles.wrap, className)}>
    <a className={styles.link} href="https://www.duolingo.com/learn">
      Duolingo
    </a>
    <a className={styles.link} href="https://www.duolingo.com/info">
      About
    </a>
    <a className={styles.link} href="https://careers.duolingo.com">
      Careers
    </a>
    <a className={styles.link} href="https://www.duolingo.com/mobile">
      Apps
    </a>
    <a className={styles.link} href="https://investors.duolingo.com">
      Investors
    </a>
    <a className={styles.link} href="https://www.duolingo.com/help">
      Help
    </a>
    <a className={styles.link} href="https://www.duolingo.com/terms">
      Terms
    </a>
    <a className={styles.link} href="https://www.duolingo.com/privacy">
      Privacy
    </a>
  </nav>
);

const Footer = () => (
  <footer className={styles.footer}>
    <FooterLinksResponsive />
  </footer>
);

export default Footer;
